import {
  Box, Text,
} from '@usealloy/component-library';
import styled from 'styled-components';


export const StyledBox = styled(Box)`
  && {
    align-items: center;
    justify-content: flex-end;
    padding-right: var(--cl-space-4);
    font-family: var(--cl-font-family-mono);
    font-size: var(--cl-font-size-2);
    gap: var(--cl-space-1);
  }
`;

export const StyledLastHeader = styled(Box)`
  button {
    opacity: 0;
  }

  &:hover button {
    opacity: 1;
  }
`;

export const StyledGrayText = styled(Text)`
  && {
    color: var(--cl-gray-700);
    text-wrap: nowrap;
  }
`;

export const StyledTextField = styled.input`
  &&& {
    background-color: transparent;
    border: none;
    border-radius: var(--cl-radius-1);
    field-sizing: content;
    font-weight: var(--cl-font-weight-bold);
    line-height: var(--cl-line-height-2);
    padding: var(--cl-space-1);

    &::placeholder {
      font-weight: bold;
      color: black;
    }
  
    &:hover {
      background-color: var(--cl-yellow-100);
    }

    &:focus {
      outline: none;
      background-color: var(--cl-yellow-200);
    }
  
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;
